// extracted by mini-css-extract-plugin
export default {"PrivacyPage":"P-75JyCdh8Afa4LihokLSQ==","TableHead":"_7ODNsaeodky0n4bpK-fKtw==","TableMainCol":"ijetdzlk+rGkM4mjfelxxQ=="};